import { SelectChangeEvent } from "@mui/material";
import { MouseEvent } from "react";
import { AddOrganizationLocalStorage, AddWorkspaceLocalStorage, RemoveWorkspaceLocalStorage } from "../../../pages/PublicLayout/RedirectManager";

export type SidebarNavigation = "organization" | "workspace"

export function SidebarOnChangeNavigationHandler (
    handlerCriteria: SidebarNavigation,
    selectEvent: SelectChangeEvent | undefined,
    setOrganization: (set: string) => void,
    setWorkspace: (set: string) => void,
    GetWorkspaceAboutOrganizationState: (param: string) => void,
    mouseEvent?: MouseEvent<HTMLLIElement, globalThis.MouseEvent>,
  ) {
    switch(handlerCriteria) {
      case "organization":
        if (selectEvent != undefined) {
          setOrganization(selectEvent.target.value);
          setWorkspace("");
    
          GetWorkspaceAboutOrganizationState(selectEvent.target.value);
          AddOrganizationLocalStorage(selectEvent.target.value);
          RemoveWorkspaceLocalStorage();
        } else if (mouseEvent != undefined) {
          setOrganization(mouseEvent.currentTarget.id);
          setWorkspace("");
          
          GetWorkspaceAboutOrganizationState(mouseEvent.currentTarget.id);
          AddOrganizationLocalStorage(mouseEvent.currentTarget.id);    
          RemoveWorkspaceLocalStorage();
        }
        break;
      case "workspace":
        if (selectEvent != undefined) {
          setWorkspace(selectEvent.target.value);
          AddWorkspaceLocalStorage(selectEvent.target.value);
        } else if (mouseEvent != undefined) {
          setWorkspace(mouseEvent.currentTarget.id);
          AddWorkspaceLocalStorage(mouseEvent.currentTarget.id);
        }
        break;
    }
  }